module.exports = __webpack_public_path__ + "img/support-question.70b8f709.png";